import { BUTTON_BORDER_RADIUS, ButtonTheme } from 'components/Button';
import { Menu } from 'components/Menu';
import { capitalize } from 'lodash';
import React, { useCallback } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { TimescaleArray, TimescalePeriod } from 'types/types';
import { NumberSpinner } from './NumberSpinner';
import { theme } from 'lib/theme';
import { SeparatorVertical } from 'components/SeparatorVertical';

const DateFieldWidth = 120;

interface Props {
  timescale: TimescaleArray;
  onChange: (timescale: TimescaleArray) => void;
  style?: StyleProp<ViewStyle>;
}

export const TimescaleField: React.FC<Props> = ({
  onChange,
  timescale: [value, unit],
  style,
}) => {
  const handleValueChange = useCallback(
    (newValue: number) => {
      onChange([newValue, unit]);
    },
    [onChange, unit],
  );

  const handleUnitChange = useCallback(
    (newUnit: TimescalePeriod) => onChange([value, newUnit]),
    [onChange, value],
  );

  return (
    <View
      style={[
        {
          // width: DateFieldWidth,
          flexDirection: 'row',
          borderWidth: 1,
          borderColor: theme.colors.blue80,
          borderRadius: BUTTON_BORDER_RADIUS,
          overflow: 'hidden',
        },
        style,
      ]}
    >
      <NumberSpinner
        value={value}
        onChange={(val) => handleValueChange(val)}
        small
        style={{
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }}
        withBorder={false}
      />
      <SeparatorVertical />
      <Menu
        width={DateFieldWidth}
        buttonConfig={{
          buttonTheme: ButtonTheme.secondary,
          text: `${capitalize(unit[0])}`,
          textWeight: 'regular',
          textStyle: {
            textAlign: 'center',
            width: '100%',
          },
          paddingLeft: 0,
          paddingRight: 0,
          glass: false,
          width: 31,
          style: {
            justifyContent: 'center',
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
        }}
        options={[
          {
            text: `Day${value > 1 ? 's' : ''}`,
            onPress: () => handleUnitChange(TimescalePeriod.day),
          },
          {
            text: `Week${value > 1 ? 's' : ''}`,
            onPress: () => handleUnitChange(TimescalePeriod.week),
          },
          {
            text: `Month${value > 1 ? 's' : ''}`,
            onPress: () => handleUnitChange(TimescalePeriod.month),
          },
          {
            text: `Year${value > 1 ? 's' : ''}`,
            onPress: () => handleUnitChange(TimescalePeriod.year),
          },
        ]}
      />
    </View>
  );
};
